import { useCallback, useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import Button from "../../extra/Button";
import Input from "../../extra/Input";
import { CLOSE_DIALOGUE } from "../../store/dialogue/dialogue.type";
import { getFakeSellerDropDown } from "../../store/fake Seller/fakeSeller.action";

import { MenuItem, Select } from "@mui/material";
import defaultImage from "../../../assets/images/default.jpg";
import {
  createFakeReel,
  updateFakeReel,
} from "../../store/fakeReels/fakeReels.action";
import { getSellerProduct } from "../../store/seller/seller.action";

const VIDEO_TYPE = {
  FILE: 1,
  LINK: 2,
};

const INITIAL_ERROR_STATE = {
  video: "",
  videoPath: "",
  sellerType: "",
  selectedOptions: "",
  thumbnail: "",
  thumbnailPath: "",
};

const FakeReelDialogue = (props) => {
  const dispatch = useDispatch();

  const { fakeSeller } = useSelector((state) => state.fakeSeller);

  const { dialogueData } = useSelector((state) => state.dialogue);
  const { product } = useSelector((state) => state.seller);

  const [mongoId, setMongoId] = useState("");
  const [sellerType, setSellerType] = useState("");
  const [videoType, setVideoType] = useState(VIDEO_TYPE.FILE);
  const [videoPath, setVideoPath] = useState(null);

  const [thumbnail, setThumbnail] = useState([]);
  const [thumbnailPath, setThumbnailPath] = useState("");
  const [duration, setDuration] = useState(0);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [video, setVideo] = useState({
    file: "",
    thumbnailBlob: "",
  });

  const [error, setError] = useState(INITIAL_ERROR_STATE);

  // INIT from dialogueData
  useEffect(() => {
    if (dialogueData) {
      setMongoId(dialogueData?._id || "");
      setSellerType(dialogueData?.sellerId?._id || "");
      setVideoType(dialogueData?.videoType || VIDEO_TYPE.FILE);
      setVideoPath(dialogueData?.video || null);

      // Edit mode: yahan server se aane wali string ko state me daal rahe ho
      setVideo({
        file: "",
        thumbnailBlob: "",
      });

      setThumbnail(dialogueData?.thumbnail || "");
      setThumbnailPath(dialogueData?.thumbnail || "");

      if (dialogueData?.duration) {
        setDuration(dialogueData.duration);
      }

      if (dialogueData?.productId && Array.isArray(dialogueData.productId)) {
        setSelectedOptions(dialogueData.productId.map((item) => item._id));
      } else {
        setSelectedOptions([]);
      }
    }
  }, [dialogueData]);

  // Fetch sellers + products
  useEffect(() => {
    dispatch(getFakeSellerDropDown());
  }, [dispatch]);

  useEffect(() => {
    if (sellerType) {
      dispatch(getSellerProduct(sellerType));
    }
  }, [dispatch, sellerType]);

  // helper: get duration from file
  const getVideoDuration = useCallback((file) => {
    return new Promise((resolve, reject) => {
      const videoEl = document.createElement("video");
      videoEl.preload = "metadata";

      videoEl.onloadedmetadata = () => {
        window.URL.revokeObjectURL(videoEl.src);
        resolve(videoEl.duration);
      };

      videoEl.onerror = () => {
        reject("Error loading video metadata");
      };

      videoEl.src = URL.createObjectURL(file);
    });
  }, []);

  // helper: generate thumbnail from file
  const generateThumbnailBlob = useCallback(async (file) => {
    return new Promise((resolve) => {
      const videoEl = document.createElement("video");
      videoEl.preload = "metadata";

      videoEl.onloadedmetadata = () => {
        videoEl.currentTime = 1;
      };

      videoEl.onseeked = async () => {
        const canvas = document.createElement("canvas");
        canvas.width = videoEl.videoWidth;
        canvas.height = videoEl.videoHeight;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(videoEl, 0, 0, canvas.width, canvas.height);

        canvas.toBlob((blob) => {
          resolve(blob);
        }, "image/jpeg");
      };

      const objectURL = URL.createObjectURL(file);
      videoEl.src = objectURL;

      return () => {
        URL.revokeObjectURL(objectURL);
      };
    });
  }, []);

  const handleVideo = async (e) => {
    const file = e.target.files[0];

    if (!file) {
      setError((prev) => ({ ...prev, video: "Please select a video!" }));
      return;
    }

    setVideoPath(URL.createObjectURL(file));
    setError((prev) => ({ ...prev, video: "" }));

    // duration
    try {
      const videoDuration = await getVideoDuration(file); // seconds [web:7][web:17]
      setDuration(videoDuration);
    } catch (err) {
      console.error(err);
    }

    // thumbnail
    const thumbnailBlob = await generateThumbnailBlob(file);
    if (thumbnailBlob) {
      const videoFileName = file?.name || "video";
      const thumbnailFileName = `${videoFileName.replace(/\.[^/.]+$/, "")}.jpeg`;

      const thumbFile = new File([thumbnailBlob], thumbnailFileName, {
        type: "image/jpeg",
      });

      setThumbnail(thumbFile);
      setThumbnailPath(URL.createObjectURL(thumbFile));
      setVideo({
        file,
        thumbnailBlob: thumbFile,
      });
    }
  };

  const handleImage = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setError((prev) => ({ ...prev, thumbnail: "" }));
    setThumbnail(file);
    setThumbnailPath(URL.createObjectURL(file));
  };

  const options =
    product?.map((item) => ({
      value: item._id,
      label: item.productName,
    })) || [];

  const validateForm = () => {
    const errors = {};

    if (!sellerType) {
      errors.sellerType = "Seller is Required !";
    }

    // file or link
    if (!video.file && !videoPath) {
      errors.video = "Please select a video!";
    }

    if (!thumbnail) {
      errors.thumbnail = "Please select a Thumbnail !";
    }

    return errors;
  };

  const handleSubmit = async () => {
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setError({ ...INITIAL_ERROR_STATE, ...validationErrors });
      return;
    }

    const formData = new FormData();

    formData.append("sellerId", sellerType);
    formData.append("productIds", selectedOptions.join(","));
    formData.append("videoType", videoType);
    formData.append("duration", duration);

    // video
    if (mongoId && !video.file) {
      // edit mode & user ne naya file nahi diya
      formData.append("video", videoPath);
    } else {
      if (Number(videoType) === VIDEO_TYPE.LINK) {
        formData.append("video", videoPath);
      } else {
        formData.append("video", video?.file);
      }
    }

    // thumbnail
    formData.append("thumbnail", thumbnail);

    try {
      if (mongoId) {
        await props.updateFakeReel(formData, sellerType, mongoId);
      } else {
        await props.createFakeReel(formData);
      }
      dispatch({ type: CLOSE_DIALOGUE });
    } catch (err) {
      console.error("Error submitting form:", err);
    }
  };

  return (
    <>
      <div className="mainDialogue fade-in">
        <div className="Dialogue">
          <div className="dialogueHeader">
            <div className="headerTitle fw-bold">Fake Reel</div>
            <div
              className="closeBtn "
              onClick={() => {
                dispatch({ type: CLOSE_DIALOGUE });
              }}
            >
              <i className="fa-solid fa-xmark"></i>
            </div>
          </div>

          <div className="dialogueMain">
            <div className="row">
              {/* Seller */}
              <div className="col-12">
                <label
                  className="styleForTitle mb-2"
                  style={{ color: "#000", fontSize: "14px" }}
                >
                  Seller
                </label>
                <select
                  name="type"
                  className="form-control form-control-line"
                  id="type"
                  value={sellerType}
                  onChange={(e) => {
                    const value = e.target.value;
                    setSellerType(value);
                    if (!value) {
                      setError((prev) => ({
                        ...prev,
                        sellerType: "Seller is Required !",
                      }));
                    } else {
                      setError((prev) => ({ ...prev, sellerType: "" }));
                      setSelectedOptions([]);
                      props.getSellerProduct(value);
                    }
                  }}
                >
                  <option value="" disabled>
                    Select seller
                  </option>
                  {fakeSeller?.map((data) => (
                    <option key={data?._id} value={data?._id}>
                      {data.firstName + " " + data.lastName}
                    </option>
                  ))}
                </select>
                {error.sellerType && (
                  <div className="pl-1 text-left">
                    <p className="errorMessage">{error.sellerType}</p>
                  </div>
                )}
              </div>

              {/* Products multi-select */}
              <div className="col-12">
                <label
                  className="styleForTitle my-2"
                  style={{
                    color: "#000",
                    fontSize: "14px",
                    display: "block",
                    marginBottom: "6px",
                  }}
                >
                  Product
                </label>
                <Select
                  style={{ width: "100%" }}
                  multiple
                  value={selectedOptions}
                  onChange={(e) => setSelectedOptions(e.target.value)}
                  displayEmpty
                  renderValue={(selected) => {
                    if (selected.length === 0) {
                      return (
                        <span style={{ color: "#000", fontSize: "15px" }}>
                          Select products
                        </span>
                      );
                    }
                    return selected
                      .map(
                        (value) =>
                          options.find((option) => option.value === value)
                            ?.label
                      )
                      .join(", ");
                  }}
                  sx={{
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#C41E3A",
                    },
                  }}
                >
                  {options.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </div>

              {/* Duration display (read only) */}
              <div className="col-12 mt-2">
                <Input
                  label="Duration (seconds)"
                  id="duration"
                  type="text"
                  value={duration ? duration.toFixed(2) : 0}
                  disabled
                  readOnly
                />
              </div>

              {/* Video type */}
              <div className="col-12">
                <div className="d-flex align-items-center mt-3">
                  <label
                    className="mb-3"
                    style={{ color: "#000", fontSize: "14px" }}
                  >
                    Video Type :-
                  </label>
                  <Input
                    label="File"
                    name="file"
                    id="file"
                    type="radio"
                    value={VIDEO_TYPE.FILE}
                    checked={Number(videoType) === VIDEO_TYPE.FILE}
                    newClass="me-3 ms-2 mb-2"
                    onClick={(e) => setVideoType(parseInt(e.target.value, 10))}
                  />
                  <Input
                    label="Link"
                    name="file"
                    id="link"
                    type="radio"
                    value={VIDEO_TYPE.LINK}
                    newClass="mb-2"
                    checked={Number(videoType) === VIDEO_TYPE.LINK}
                    onClick={(e) => setVideoType(parseInt(e.target.value, 10))}
                  />
                </div>
              </div>

              {/* File upload */}
              <div className={Number(videoType) === VIDEO_TYPE.FILE ? "col-12" : "d-none"}>
                <Input
                  label="Video"
                  id="video"
                  type="file"
                  accept="video/*"
                  errorMessage={error.video}
                  onChange={handleVideo}
                />

                {video?.file && video?.thumbnailBlob ? (
                  <div className="">
                    <video
                      controls
                      style={{ width: "200px", height: "200px" }}
                      src={URL.createObjectURL(video.file)}
                      crossOrigin="anonymous"
                    />
                    <img
                      src={URL.createObjectURL(video.thumbnailBlob)}
                      style={{
                        width: "200px",
                        height: "200px",
                        position: "absolute",
                        marginLeft: "36px",
                      }}
                      alt="Video thumbnail"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = defaultImage;
                      }}
                    />
                  </div>
                ) : (
                  <>
                    {videoPath && thumbnail && (
                      <div className="">
                        <video
                          controls
                          style={{ width: "200px", height: "200px" }}
                          src={videoPath}
                          crossOrigin="anonymous"
                        />
                        <img
                          src={thumbnail}
                          style={{
                            width: "200px",
                            height: "200px",
                            position: "absolute",
                            marginLeft: "36px",
                          }}
                          alt="Thumbnail"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = defaultImage;
                          }}
                        />
                      </div>
                    )}
                  </>
                )}
              </div>

              {/* Link upload */}
              <div className={Number(videoType) === VIDEO_TYPE.LINK ? "col-12" : "d-none"}>
                <Input
                  label="Link"
                  placeholder="link"
                  id="link"
                  type="text"
                  value={videoPath || ""}
                  errorMessage={error.video}
                  onChange={(e) => {
                    const value = e.target.value;
                    setVideoPath(encodeURI(value)); // ← URL encode for spaces
                    if (!value) {
                      setError((prev) => ({
                        ...prev,
                        video: "Video Link Is Required",
                      }));
                    } else {
                      setError((prev) => ({ ...prev, video: "" }));
                    }
                  }}
                />
                {videoPath && (
                  <div className="image-start">
                    <video
                      controls
                      src={videoPath}
                      draggable="false"
                      width={100}
                      height={100}
                      // ← crossOrigin="anonymous" REMOVE KARO - Yeh CORS error de raha hai
                      className="m-0"
                      onError={(e) => {
                        console.error("Video error code:", e.target.error?.code);
                        console.error("Video error message:", e.target.error?.message);
                      }}
                      onLoadedData={() => console.log("Video loaded successfully")}
                    >
                      <source src={videoPath} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  </div>
                )}

                <div className="col-12">
                  <Input
                    label="Thumbnail"
                    id="image"
                    type="file"
                    accept="image/*"
                    errorMessage={error.thumbnail}
                    onChange={handleImage}
                  />
                  {thumbnailPath && (
                    <div className="image-start">
                      <img
                        src={thumbnailPath}
                        draggable="false"
                        width={100}
                        height={100}
                        className="m-0"
                        alt="Thumbnail preview"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = defaultImage;
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>

            </div>
          </div>

          {/* Footer */}
          <div className="dialogueFooter">
            <div className="dialogueBtn">
              <Button
                btnName={mongoId ? "Update" : "Submit"}
                btnColor="btnBlackPrime text-light"
                style={{ borderRadius: "5px", width: "80px" }}
                newClass="me-2"
                onClick={handleSubmit}
              />
              <Button
                btnName="Close"
                btnColor="myCustomButton"
                style={{ borderRadius: "5px", width: "80px" }}
                onClick={() => {
                  dispatch({ type: CLOSE_DIALOGUE });
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default connect(null, {
  getFakeSellerDropDown,
  createFakeReel,
  updateFakeReel,
  getSellerProduct,
})(FakeReelDialogue);
